import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { DeviceID, TraitsResponse } from '@playq/octopus2-devices';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { deviceToolkit } from '/store';

export const traitsDevices: unknown[] = ['traits', 'devices'];
export const useGetTraits = (
  options?: IUseQueryOptionsExtended<TraitsResponse | undefined, GenericFailure | Error>
) => {
  const location = useLocation<{ refetch?: string }>();

  const subscribtionDevice = useSelector(deviceToolkit.selectors.subscribtionDevice);
  const { mutate: _mutate, ...res } = useEitherQuery(
    traitsDevices.concat(subscribtionDevice?.device.id, location.state?.refetch),
    () => {
      return services2.onlineSubscriptionService.traits(new DeviceID(subscribtionDevice?.device.id));
    },
    {
      staleTime: 0,
      cacheTime: 0,
      ...options,
    }
  );
  const traits = useMemo(() => res.data?.traits || [], [res.data?.traits]);
  return { ...res, traits };
};
